import React from 'react';

const SkillsSection = () => {
  const skillCategories = [
    {
      category: 'Frontend',
      skills: ['React.js', 'Next.js', 'TypeScript', 'Tailwind CSS']
    },
    {
      category: 'Backend',
      skills: ['Node.js', 'Express.js', 'MongoDB', 'PostgreSQL']
    },
    {
      category: 'Mobile',
      skills: ['React Native', 'Expo', 'iOS/Android', 'App Store']
    },
    {
      category: 'AI & ML',
      skills: ['LangChain', 'RAG Systems', 'OpenAI APIs', 'Agentic AI']
    },
    {
      category: 'Cloud & DevOps',
      skills: ['AWS', 'Vercel', 'Docker', 'CI/CD Pipeline']
    },
    {
      category: 'Tools & Design',
      skills: ['Git/GitHub', 'VS Code', 'Figma', 'Linear']
    }
  ];

  return (
    <section className="skills-simple">
      {/* Floating Particles */}
      <div className="floating-particles">
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>

      <div className="container">
        <div className="section__header">
          <div className="section__badge">
            <span>🛠️</span>
            <span>Technical Skills</span>
          </div>
          
          <h2 className="section__title">
            Expertise in <span className="text--accent">Modern Technologies</span>
          </h2>
          
          <p className="section__description">
            Specialized in cutting-edge technologies with focus on AI integration and scalable solutions.
          </p>
        </div>

        <div className="skills__grid">
          {skillCategories.map((category, index) => (
            <div key={index} className="skill-group">
              <h3 className="group__title">{category.category}</h3>
              <div className="group__skills">
                {category.skills.map((skill, skillIndex) => (
                  <span key={skillIndex} className="skill-item">
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="skills__highlight">
          <p className="highlight__text">
            Currently focused on <span className="highlight--ai">AI-powered applications</span>, 
            <span className="highlight--performance"> performance optimization</span>, and 
            <span className="highlight--ux"> exceptional user experiences</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;